if (!customElements.get("nmn-reading-heading")) {
  customElements.define(
    "nmn-reading-heading",
    class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
        const primary = this.querySelector("[data-reading-primary]");
        const column = this.closest(".nmn-nad__heading-column");
        const opening = this.closest(".nmn-product-content__opening");
        if (!primary || !column || !opening) return;

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
        const desktop = matchMedia("(min-width: 990px)");
        const update = () => {
          this.frame = null;
          const height = primary.getBoundingClientRect().height;
          column.style.setProperty("--nmn-reading-height", `${height}px`);
          if (reducedMotion.matches) {
            this.style.setProperty("--nmn-reading-progress", "0");
            return;
          }
          const pinTop = parseFloat(getComputedStyle(this).top) || 0;
          const gap = parseFloat(getComputedStyle(document.documentElement).fontSize) * 2.4;
          const distance = height * 2 + gap;
          const halfway = window.innerHeight / 2;
          const progress = desktop.matches
            ? Math.min(1, Math.max(0, (halfway - opening.getBoundingClientRect().top) / halfway))
            : Math.min(1, Math.max(0, (pinTop - column.getBoundingClientRect().top) / distance));
          this.style.setProperty("--nmn-reading-progress", String(progress));
        };
        const schedule = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(update);
        };
        window.addEventListener("scroll", schedule, { ...options, passive: true });
        window.addEventListener("resize", schedule, options);
        reducedMotion.addEventListener("change", schedule, options);
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(primary);
        schedule();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    },
  );
}
